import { useSelector } from "react-redux";
import { selectPropCategories } from "../../app/slices/PropLibrarySlice";

const hexToRgb = (hex: string) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
};

/**
 * Tinted category name chip, as the frames draw on cards, rows and the
 * details pane. Colour is API data (`hexColor`), not a token.
 */
export function PropCategoryChips(props: {
  categoryIds: { id: string }[];
  max?: number;
}) {
  const { categoryIds, max = 3 } = props;
  const categories = useSelector(selectPropCategories);

  const resolved = categoryIds
    .map((ref) => categories.find((category) => category.id === ref.id))
    .filter((category): category is NonNullable<typeof category> => !!category)
    .slice(0, max);

  return (
    <>
      {resolved.map((category) => {
        const rgb = hexToRgb(category.hexColor);
        return (
          <span
            key={category.id}
            style={{
              color: category.hexColor,
              backgroundColor: rgb
                ? `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.12)`
                : undefined,
            }}
            className="px-[8px] py-[2px] rounded-full text-[10px] leading-[14px] whitespace-nowrap"
          >
            {category.name.charAt(0).toUpperCase() + category.name.slice(1)}
          </span>
        );
      })}
    </>
  );
}

/** Small outlined version tag — `v0.4` — as the frames draw it. */
export function PropVersionTag(props: { version: number }) {
  return (
    <span className="px-[6px] py-[2px] rounded-[4px] border border-creator-border text-[9px] leading-[12px] text-creator-text-sub whitespace-nowrap">
      {"v0." + props.version}
    </span>
  );
}
